import DonationFormField from '@/donationPages/_dependencies/components/DonationFormField'
import FormCheckbox from '@/form/FormCheckbox'
import I18nHtml from '@/components/I18nHtml'
import styles from './AddressFieldToggle.module.css'
import { Heading, LayoutStack } from '@betterplace/design-system/client'
import { type ReactNode, useEffect } from 'react'
import { useDonationFormContext, useDonationFormValues } from '@/donationPages/_dependencies/helpers'
import { useTranslations } from 'next-intl'

function AddressFieldToggle({ children }: { children: ReactNode }) {
  const { setValue } = useDonationFormContext()
  const [receiptDesired] = useDonationFormValues(['receipt_desired'])
  const t = useTranslations('nextjs.donate')

  useEffect(() => {
    if (receiptDesired) return
    setValue('street', '', { shouldValidate: true })
    setValue('zip', '', { shouldValidate: true })
    setValue('city', '', { shouldValidate: true })
  }, [receiptDesired, setValue])
  return (
    <>
      <Heading level="heading-xs" className={styles.headingMargin}>
        {t('donation_receipt')}
      </Heading>
      <LayoutStack space="200">
        <DonationFormField name="receipt_desired" id="receiveReceipt" as={FormCheckbox}>
          <I18nHtml i18nKey="nextjs.donate.receipt_desired_html" />
        </DonationFormField>
        {receiptDesired && children}
      </LayoutStack>
    </>
  )
}
export default AddressFieldToggle
